var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.819373 30.0748C0.411033 29.6701 0.181641 29.1213 0.181641 28.5491C0.181641 27.9768 0.411033 27.428 0.819373 27.0233L12.3483 15.6008L0.819373 4.17826C0.422606 3.77125 0.203061 3.22612 0.208024 2.66029C0.212986 2.09446 0.442059 1.55319 0.845905 1.15307C1.24975 0.752954 1.79606 0.525995 2.36716 0.521078C2.93826 0.516161 3.48847 0.73368 3.89927 1.12679L16.9682 14.0751C17.3765 14.4797 17.6059 15.0286 17.6059 15.6008C17.6059 16.173 17.3765 16.7218 16.9682 17.1265L3.89927 30.0748C3.49081 30.4794 2.93689 30.7066 2.35932 30.7066C1.78176 30.7066 1.22784 30.4794 0.819373 30.0748Z","fill":"#3B79D6"}));
}

ArrowNext.defaultProps = {"width":"18","height":"31","viewBox":"0 0 18 31","fill":"none"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
